import Belova1 from '../../../Media/BSD/Terravia/Terravia Belova.webp'
import Belova2 from '../../../Media/BSD/Terravia/Terravia Belova.webp'





const Belovaimages =[ Belova1,Belova2
]

export default Belovaimages;